<script>
  import { site } from './store.js'
</script>


<div style="display:flex; flex-wrap: no-wrap; background-color: #333;">
  <div style="flex: 1 1 20%; background-color: { $site.color.primary }; padding: 60px; color: white; font-size: 14px;">
    <p>{ $site.phone }</p>
    <p>{ $site.name }</p>
    <p>{ $site.address.street }</p>
    <p>{ $site.address.city } { $site.address.state } { $site.address.postal_code } { $site.address.country }</p>
  </div>
  <div class="footer-menus" style="flex: 1 1 80%; padding: 60px 60px 10px;">
    <div class="footer-menu" style="display: flex; flex-wrap: wrap; color: { $site.color.link }">
      {#each $site.footer.sections as section}
        <div style="flex: 1;">
          <div class="section-title">{section.title}</div>
          {#each section.links as link}
            <a class="db mt-s ml-s ttu fss" href={link.url}>{link.name}</a>
          {/each}
        </div>
      {/each}
      <div class="social-links tar" style="flex: 1;">
        <a class="linkedin-link" href={ $site.footer.social.linkedin_link } title="LinkedIn">
          <i class="fab fa-linkedin" aria-hidden="true"></i>
          <span class="screen-reader-text">linkedin</span>
        </a>
        <a class="twitter-link" target="_blank" href={ $site.footer.social.twitter_link } title="twitter link">
          <i class="fab fa-twitter" aria-hidden="true"></i>
          <span class="screen-reader-text">twitter</span>
        </a>
      </div>
    </div>
    <div style="display: flex; margin: 40px 0 20px;">
      <div class="copyright" style="flex: 1 1 70%;">
        <p>
          <span>&copy; { (new Date).getFullYear() } { $site.name } All rights reserved.</span>
          <a class="privacy-policy-link" href="/about/privacy">Privacy Policy</a>
        </p>
      </div>
      <div class="powered" style="flex: 1 1 30%; text-align: right;">
        <p>powered by: <a href="https://www.theaero.com/" >the.aero</a></p>
      </div>
    </div>
  </div>
</div>


<style>
  .footer-menu .section-title {
    color: #999;
    letter-spacing: 1.5px;
    font-family: "Khand", Arial, sans-serif;
  }
  .footer-menu a {
    color: inherit;
    text-decoration: none;
    transition: opacity 0.35s;
    letter-spacing: 1.5px;
    font-family: "Khand", Arial, sans-serif;
  }
  .footer-menu a:hover,
  .footer-menu a:focus {
    opacity: 0.5;
    text-decoration: none;
  }
  .social-links a {
    width: 24px;
    height: 24px;
    display: inline-block;
    vertical-align: top;
    background-repeat: no-repeat;
    margin-left: 1.3rem;
    color: rgba(255,255,255,0.43);
    text-align: center;
    line-height: 0px;
    border: 1px solid rgba(255,255,255,0.43);
    border-radius: 50%;
    font-size: 12px;
    transition: border .35s, color .35s;
    text-decoration: none;
  }
  .social-links a:hover,
  .social-links a:focus {
    color: #fff;
    border: 1px solid rgba(255,255,255,1);
  }
  .social-links a i {
    display: block;
    position: relative;
    top: 50%;
    transform: translate(0,-50%);
  }
  .fa-linkedin,
  .fa-twitter {
    padding-left: 2px;
  }
  /*
  .social-links a.linkedin-link {
    background-position: -81px 0;
  }
  .social-links a.twitter-link {
    background-position: -124px 0;
  }
  */
  .top-footer {
    margin-bottom: 6rem;
  }
  .copyright {
    color: rgba(255,255,255,0.45);
    font-size: 12px;
    float: left;
  }
  .powered {
    float: right;
    color: rgba(255,255,255,0.45);
    font-size: 12px;
  }
  .copyright p,
  .powered p {
    margin-bottom: 0;
  }
  .copyright a {
    margin-left: .8rem;
  }
  .powered p a,
  .copyright a {
    text-decoration: none;
    color: rgba(255,255,255,0.45);
    transition: color .35s;
  }
  .copyright a + a {
    margin-left: 2rem;
    position: relative;
  }
  .copyright a + a:before {
    position: absolute;
    left: -1.2rem;
    top: 0;
    bottom: 0;
    background: rgba(255,255,255,0.45);
    width: 1px;
    content: '';
    pointer-events: none;
  }
  .powered p a:hover,
  .copyright a:hover,
  .powered p a:focus,
  .copyright a:focus {
    color: rgba(255,255,255,1);
  }
</style>
